import apiClient from "../../utils/apiclient";


export const login=async(reqBody:{
    email: string;
    password: string,
})=>{
   return await apiClient.post('/admin/login',reqBody)
}



export const changePassword = async (reqBody: { email: string }, token: string) => {
  return await apiClient.post('/admin/change-password',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}


export const resetPassword = async (reqBody: {old_pass?: string,new_pass:string,conf_pass:string }, token: string) => {
  return await apiClient.post('/admin/reset-password',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}


export const enetremailv1 = async (reqBody: { email: string }, token: string) => {
  return await apiClient.post('/admin/enter-email',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })
}



